module.exports = __webpack_public_path__ + "assets/certificate_pdf/Computer Knowledge Today_1120606.a5def058.pdf";